import { apiClient } from "@/lib/api";
import type { StandardResponse } from "@/types/api-response";
import { extractData } from "@/types/api-response";
import type {
  BankTransferConfigDto,
  BankTransferConfigUpdateDto,
} from "@/types/bank-transfer-config";

const BASE_URL = "/api/v1/admin/payments/bank-transfer-config";

export const adminBankTransferConfigService = {
  async getBankTransferConfig(): Promise<BankTransferConfigDto> {
    const response = await apiClient.get<StandardResponse<BankTransferConfigDto>>(
      BASE_URL,
    );
    return extractData(response.data);
  },

  async updateBankTransferConfig(
    dto: BankTransferConfigUpdateDto,
  ): Promise<BankTransferConfigDto> {
    const response = await apiClient.put<
      StandardResponse<BankTransferConfigDto>
    >(BASE_URL, dto);
    return extractData(response.data);
  },

  async syncBankTransferConfig(): Promise<BankTransferConfigDto> {
    const response = await apiClient.post<
      StandardResponse<BankTransferConfigDto>
    >(`${BASE_URL}/sync`);
    return extractData(response.data);
  },

  async rejectBankTransferConfig(): Promise<BankTransferConfigDto> {
    const response = await apiClient.post<
      StandardResponse<BankTransferConfigDto>
    >(`${BASE_URL}/reject`);
    return extractData(response.data);
  },
};
